// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jg-2";
export var container = "_jg-4";
export var dismissButton = "_jg-3";
export var hasPaddingBottom = "_jg-6";
export var last = "_jg-e";
export var scrollbarThumb = "_jg-c";
export var scrollbarTrack = "_jg-b";
export var selected = "_jg-9";
export var spin = "_jg-1";
export var spinning = "_jg-0";
export var suggestionItem = "_jg-d";
export var suggestionsPanel = "_jg-5";
export var tonePill = "_jg-8";
export var tonesContainer = "_jg-7";
export var unselected = "_jg-a";